import script from "./AudioCoursewareCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudioCoursewareCard.vue?vue&type=script&lang=ts&setup=true"

import "./AudioCoursewareCard.vue?vue&type=style&index=0&id=18d689a0&scoped=true&lang=css"
import "./AudioCoursewareCard.vue?vue&type=style&index=1&id=18d689a0&lang=less&scoped=true"
script.__scopeId = "data-v-18d689a0"

export default script